/// <reference types="@types/google.maps" />
import { MapsAPILoader } from '@agm/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
// import { Gtag } from 'angular-gtag';
import { Subject, takeUntil } from 'rxjs';
import { ProfilesService } from '../profiles.service';
import { Profile } from '../profiles.type';
@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteComponent implements OnInit, OnDestroy {
  @ViewChild("search") public searchElementRef: ElementRef;
  quoteStepperForm: FormGroup;
  profile: Profile;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  isCompleted = false;
  isEditable = true;
  constructor(
    private _formBuilder: FormBuilder,
    private _mapsAPILoader: MapsAPILoader,
    private _ngZone: NgZone,
    private _profilesService: ProfilesService,
    private _changeDetectorRef: ChangeDetectorRef,
    // private _gtag: Gtag,
    private gtmService: GoogleTagManagerService,

  ) { 



  }

  ngOnInit(): void {
    
this.gtmService.pushTag
          // Get the course
          this._profilesService.course$
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((profile: any) => {

            console.log('this.profile');
            console.log(profile);

              // Get the course
              this.profile = profile.hireProfile;

              // Go to step
            //   this.goToStep(profile.progress.currentStep);

              // Mark for check
              this._changeDetectorRef.markForCheck();
          });

    this.quoteStepperForm = this._formBuilder.group({
      step0: this._formBuilder.group({
        profile_id    : [this.profile.id]
      }),
      step1: this._formBuilder.group({
        description    : ['', [Validators.required, Validators.maxLength(3000)]]
      }),
      step2: this._formBuilder.group({
        email   : ['', [Validators.required, Validators.email]],
        phonenumber : ['', Validators.required],
        first_name: ['', Validators.required],
        last_name : ['', Validators.required],
        company_name : [''],
        // account: [true],
        // password: ['']
      }),
      step3: this._formBuilder.group({
        address : ['', Validators.required],
        city : ['', Validators.required],
        province : ['', Validators.required],
        country : ['', Validators.required],
        postal_code : [''],
        unit : [''],
        latitude : [''],
        longitude : [''],
      })
  });

      //load Places Autocomplete
      this._mapsAPILoader.load().then(() => {
        // this.logger.log('start');
        console.log("start");

        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: ["address"]
        });
        if (google! && google!.maps) {
          // this.logger.log('Google maps loaded');
        }
        // this.logger.log(autocomplete);
        autocomplete.addListener("place_changed", () => {
          this._ngZone.run(() => {
            // this.logger.log('ngZone');
  
            //get the place result
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();
            // this.logger.log(place);
  
  console.log("place");
  console.log(place);
            
            const subLocality = (place.address_components.some(elm => elm.types.includes('sublocality_level_1')) ) ?  ', ' + place.address_components.find(elm => elm.types.includes('sublocality_level_1')).long_name : '';
            console.log('subLocality');
            console.log(subLocality);
            this.quoteStepperForm.patchValue({step3: {address: place.name + subLocality}});
            this.quoteStepperForm.patchValue({step3: {city: place.address_components.find(elm => elm.types.includes('locality') || elm.types.includes('administrative_area_level_2')).long_name}});
            this.quoteStepperForm.patchValue({step3: {province: place.address_components.find(elm => elm.types.includes('administrative_area_level_1')).long_name}});
            this.quoteStepperForm.patchValue({step3: {country: place.address_components.find(elm => elm.types.includes('country')).long_name}});
            this.quoteStepperForm.patchValue({step3: { postal_code: place.address_components.find(elm => elm.types.includes('postal_code')).long_name }});
            this.quoteStepperForm.patchValue({step3: { latitude : place.geometry.location.lat() }});
            this.quoteStepperForm.patchValue({step3: { longitude : place.geometry.location.lng()}});
  
            // this.backendService.getTimezoneID(place.geometry.location.lat(), place.geometry.location.lng()).subscribe((res: any) => {
            //   this.logger.debug("timezoneId");
            //   this.logger.debug(res)
            //   if (res.status == "OK") {
            //     this.storeForm.get('timezone').setValue(res.timeZoneId);
            //   }
            // });
            //verify result
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
  
        });
      });


  });


  // this._gtag.event('conversion', {
  //   send_to: 'AW-331179958/5QP0COau_KMDELbP9Z0B',
  //   value: 10.0,
  //   currency: 'CAD'
  // });
  }

    /**
   * On destroy
   */
     ngOnDestroy(): void
     {
         // Unsubscribe from all subscriptions
         this._unsubscribeAll.next(null);
         this._unsubscribeAll.complete();
     }

     submit(stepper: MatStepper): void {
        if (this.quoteStepperForm.valid) {

          this._profilesService.submitPriceQuote(this.quoteStepperForm.value).subscribe(res => {
            // console.log("res");
            // console.log(res);
            if (!res.error) {
              this.isEditable = false;
              stepper.next();

              // this._gtag.event('success', { 
              //   method: 'onsite',
              //   event_category: 'quotation_form',
              //   event_label: 'Quotation form success'
              // });   
              const gtmTag = {
                event: 'quotation_form_success',
                method: 'onsite',
                event_category: 'quotation_form',
                event_label: 'Quotation form success'
            };
        
            this.gtmService.pushTag(gtmTag); 
            } else {
              const gtmTag = {
                event: 'quotation_form_failed',
                method: 'onsite',
                event_category: 'quotation_form',
                event_label: 'Quotation form faild'
            };
        
            this.gtmService.pushTag(gtmTag); 
            }

            // this._gtag.event('conversion', {
            //   send_to: 'AW-331179958/7scWCPfMgqQDELbP9Z0B',
            //   value: 100.0,
            //   currency: 'CAD',
            // });
          });
        } else {
          
        }
     }

     gtagEvent(event: string) {
      // this._gtag.event(event, { 
      //   method: 'onsite',
      //   event_category: 'quotation_form',
      //   event_label: 'Quotation form ' + event
      // });

      const gtmTag = {
        event: 'quotation_form_' + event,
        method: 'onsite',
        event_category: 'quotation_form',
        event_label: 'Quotation form step'
    };

    this.gtmService.pushTag(gtmTag);

     }
  get description() {
    return this.quoteStepperForm.get('step1').get('description');
  }

  // get account() {
  //   return this.quoteStepperForm.get('step2').get('account');
  // }  
  get email() {
    return this.quoteStepperForm.get('step2').get('email');
  }
  get first_name() {
    return this.quoteStepperForm.get('step2').get('first_name');
  }
  get last_name() {
    return this.quoteStepperForm.get('step2').get('last_name');
  }
  get company_name() {
    return this.quoteStepperForm.get('step2').get('company_name');
  }


  get address() {
    return this.quoteStepperForm.get('step3').get('address');
  }




}
